module.exports = __webpack_public_path__ + "static/media/vscPic.9fb6b523.svg";